"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.mapAnswersToDataCollection = void 0;
var _models = require("../models");
const mapAnswersToDataCollection = (param)=>{
    let { questions, formValues } = param;
    if (!formValues) {
        return [];
    }
    return _models.answersToSend.map((answer)=>{
        const questionIndex = _models.ConcernFormFieldsQuestionsIndex[answer];
        var _questions_questionIndex;
        return {
            questionText: (_questions_questionIndex = questions[questionIndex]) !== null && _questions_questionIndex !== void 0 ? _questions_questionIndex : '',
            responseText: formValues[answer]
        };
    }).filter((item)=>item.questionText);
};
exports.mapAnswersToDataCollection = mapAnswersToDataCollection;
